export const getId = (): string => Math.floor(Math.random() * Date.now()).toString(16);
